import { internalFetch } from '../utils/fetchHelper';
import { IPagedCollection } from '@moko/utils';

export interface IRenter {
  id: number;
  name: string;
  code: string;
  otherInfo: string;
}

export interface IUpdateRenterRequest {
  name: string;
  code: string;
  otherInfo: string;
}

export interface ICreateRenterRequest {
  name: string;
  code: string;
  otherInfo: string;
}

export interface ICreateRenterResponse {
  renterId: number;
}

export const getRenters = async (
  abortController: AbortController,
  pageSize: number,
  pageNo: number,
  orderBy?: string,
  search?: string
): Promise<IPagedCollection<IRenter>> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/renters?pageSize=${pageSize}&pageNo=${pageNo}${
      orderBy ? `&orderBy=${orderBy}` : ''
    }${search ? `&search=${search}` : ''}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const getRenter = async (
  abortController: AbortController,
  renterId?: number
): Promise<IRenter> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/renterById?renterId=${renterId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const editRenter = async (
  abortController: AbortController,
  renterId: number,
  renter: IUpdateRenterRequest
): Promise<number> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/renterById?renterId=${renterId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'PUT',
    abortController,
    JSON.stringify(renter)
  );
};

export const createRenter = async (
  abortController: AbortController,
  data: ICreateRenterRequest
): Promise<ICreateRenterResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/renter`,
    'POST',
    abortController,
    JSON.stringify(data)
  );
};
